
(function () {
  var EXCLUDED_PRODUCT_IDS = [];
  var GIFT_VARIANT_ID = 53328955605339;
  var THRESHOLD = 3;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var isBusy = false;
  var needsRerun = false;

  function injectStyles() {
    if (document.getElementById('gnb-gift-bar-styles')) return;
    var style = document.createElement('style');
    style.id = 'gnb-gift-bar-styles';
    style.textContent =
      '.gnb-gift-bar{padding:14px 16px;border-bottom:1px solid #e5e5e5;}' +
      '.gnb-gift-bar__text{font-family:"Maven Pro",sans-serif;font-size:13px;color:#030302;margin:0 0 8px;}' +
      '.gnb-gift-bar__track{width:100%;height:5px;border-radius:999px;background:#ececec;overflow:hidden;}' +
      '.gnb-gift-bar__fill{height:100%;border-radius:999px;background:#cbb89b;transition:width 0.35s ease,background-color 0.35s ease;}' +
      '.gnb-gift-bar--complete .gnb-gift-bar__fill{background:#1a7f37;}' +
      '.gnb-gift-topbar{position:fixed;top:0;left:0;right:0;width:100%;box-sizing:border-box;padding:13px 16px;background:#f3ede3;display:flex;align-items:center;justify-content:center;gap:14px;flex-wrap:wrap;z-index:999999;}' +
      '.gnb-gift-topbar__text{font-family:inherit;font-size:12px;font-weight:400;color:#030302;margin:0;text-align:center;letter-spacing:0.01em;}' +
      '.gnb-gift-topbar__track{width:160px;max-width:40vw;height:7px;border-radius:999px;background:#e2d8c8;overflow:hidden;flex-shrink:0;}' +
      '.gnb-gift-topbar__fill{height:100%;border-radius:999px;background:#a98e63;transition:width 0.35s ease,background-color 0.35s ease;}' +
      '.gnb-gift-topbar--complete .gnb-gift-topbar__fill{background:#1a7f37;}' +
      '@media (max-width:480px){.gnb-gift-topbar{padding:11px 12px;gap:10px;}.gnb-gift-topbar__text{font-size:11px;}.gnb-gift-topbar__track{width:110px;}}';
    document.head.appendChild(style);
  }

  function countEligible(cart) {
    var count = 0;
    cart.items.forEach(function (item) {
      if (item.variant_id === GIFT_VARIANT_ID) return;
      if (EXCLUDED_PRODUCT_IDS.indexOf(item.product_id) !== -1) return;
      count += item.quantity;
    });
    return count;
  }

  function findGiftLine(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === GIFT_VARIANT_ID) return cart.items[i];
    }
    return null;
  }

  function renderBar(cart) {
    injectStyles();
    var dialog = document.querySelector('.cart-drawer__dialog, cart-drawer-component dialog');
    if (!dialog) return;

    var count = countEligible(cart);
    var remaining = Math.max(THRESHOLD - count, 0);
    var pct = Math.min((count / THRESHOLD) * 100, 100);

    var bar = dialog.querySelector('.gnb-gift-bar');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'gnb-gift-bar';
      bar.innerHTML = '<p class="gnb-gift-bar__text"></p><div class="gnb-gift-bar__track"><div class="gnb-gift-bar__fill"></div></div>';
      dialog.insertBefore(bar, dialog.firstChild);
    }

    var text = bar.querySelector('.gnb-gift-bar__text');
    var fill = bar.querySelector('.gnb-gift-bar__fill');

    if (remaining > 0) {
      bar.classList.remove('gnb-gift-bar--complete');
      text.textContent = 'Plus que ' + remaining + ' article' + (remaining > 1 ? 's' : '') + ' pour recevoir votre trousse de toilette offerte 🎁';
    } else {
      bar.classList.add('gnb-gift-bar--complete');
      text.textContent = 'Votre trousse de toilette offerte a été ajoutée 🎁';
    }
    fill.style.width = pct + '%';
  }

  function renderTopBar(cart) {
    injectStyles();

    var count = countEligible(cart);
    var remaining = Math.max(THRESHOLD - count, 0);
    var pct = Math.min((count / THRESHOLD) * 100, 100);

    var bar = document.querySelector('.gnb-gift-topbar');
    var spacer = document.querySelector('.gnb-gift-topbar-spacer');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'gnb-gift-topbar';
      bar.innerHTML = '<p class="gnb-gift-topbar__text"></p><div class="gnb-gift-topbar__track"><div class="gnb-gift-topbar__fill"></div></div>';
      document.body.insertBefore(bar, document.body.firstChild);

      spacer = document.createElement('div');
      spacer.className = 'gnb-gift-topbar-spacer';
      bar.parentNode.insertBefore(spacer, bar.nextSibling);
    }

    var text = bar.querySelector('.gnb-gift-topbar__text');
    var fill = bar.querySelector('.gnb-gift-topbar__fill');

    if (remaining > 0) {
      bar.classList.remove('gnb-gift-topbar--complete');
      text.textContent = 'Plus que ' + remaining + ' article' + (remaining > 1 ? 's' : '') + ' pour recevoir votre trousse de toilette offerte';
    } else {
      bar.classList.add('gnb-gift-topbar--complete');
      text.textContent = 'Votre trousse de toilette offerte a été ajoutée';
    }
    fill.style.width = pct + '%';

    // Pousse le contenu du site vers le bas pour que la jauge (fixe en haut)
    // ne cache rien : un espaceur de la même hauteur qu'elle, ré-ajusté à
    // chaque changement de texte (le texte peut passer sur 2 lignes en mobile).
    requestAnimationFrame(function () {
      if (spacer) spacer.style.height = bar.offsetHeight + 'px';
    });

    updateTopBarVisibility();
  }

  function finishCycle() {
    isBusy = false;
    if (needsRerun) {
      needsRerun = false;
      ensureGift();
    }
  }

  function ensureGift() {
    if (isBusy) {
      needsRerun = true;
      return;
    }
    isBusy = true;

    fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        // Le nombre d'articles éligibles (et donc le message affiché) ne
        // dépend pas de la présence du cadeau lui-même : on affiche tout de
        // suite le bon état, sans attendre la confirmation de l'ajout/retrait
        // du cadeau, pour que ce soit instantané à l'écran.
        renderBar(cart);
        renderTopBar(cart);

        var count = countEligible(cart);
        var giftLine = findGiftLine(cart);

        if (count >= THRESHOLD && !giftLine) {
          fetch(root + 'cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: GIFT_VARIANT_ID, quantity: 1 })
          })
            .catch(function () {})
            .then(finishCycle);
          return;
        }

        if (count < THRESHOLD && giftLine) {
          fetch(root + 'cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: giftLine.key, quantity: 0 })
          })
            .catch(function () {})
            .then(finishCycle);
          return;
        }

        finishCycle();
      })
      .catch(finishCycle);
  }

  // Détecte tout ajout / modification du panier, quel que soit le bouton
  // à l'origine de l'action (fiche produit, panier, bouton rapide, etc.).
  var originalFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0] instanceof Request ? arguments[0].url : arguments[0];
    var isCartCall = typeof url === 'string' && /\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url);
    return originalFetch.apply(this, arguments).then(function (response) {
      if (isCartCall) {
        setTimeout(ensureGift, 50);
      }
      return response;
    });
  };

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-testid="cart-drawer-trigger"]');
    if (trigger) {
      setTimeout(ensureGift, 150);
    }
  });

  window.addEventListener('resize', function () {
    var bar = document.querySelector('.gnb-gift-topbar');
    var spacer = document.querySelector('.gnb-gift-topbar-spacer');
    if (bar && spacer) spacer.style.height = bar.offsetHeight + 'px';
  });

  // Le menu (mobile) et le panier s'ouvrent tous les deux dans un <dialog>.
  // Tant qu'un de ces panneaux est ouvert, on masque le bandeau du haut pour
  // qu'il ne cache pas son contenu (logo, croix de fermeture, etc.).
  function updateTopBarVisibility() {
    var bar = document.querySelector('.gnb-gift-topbar');
    var spacer = document.querySelector('.gnb-gift-topbar-spacer');
    if (!bar) return;
    var hide = !!document.querySelector('dialog[open]');
    bar.style.display = hide ? 'none' : '';
    if (spacer) spacer.style.display = hide ? 'none' : '';
  }

  new MutationObserver(updateTopBarVisibility).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['open'],
    subtree: true
  });

  document.addEventListener('DOMContentLoaded', ensureGift);
  if (document.readyState !== 'loading') ensureGift();
})();